import { render, staticRenderFns } from "./LoadingElement.vue?vue&type=template&id=5957aad5&"
import script from "./LoadingElement.vue?vue&type=script&lang=js&"
export * from "./LoadingElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports